export default __webpack_public_path__ + "static/media/76-min.838109ea.jpg";